import { render, staticRenderFns } from "./RoadUserAccidentResolution.vue?vue&type=template&id=3a2e9164"
import script from "./RoadUserAccidentResolution.vue?vue&type=script&lang=js"
export * from "./RoadUserAccidentResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports